import { KTSVG, WithChildren, checkIsActive } from '../../../helpers'
import React, { useEffect, useRef } from 'react'

import { MUIIcon } from '../../../framework/widgets'
import clsx from 'clsx'
import { useLayout } from '../../core'
import { useLocation } from 'react-router'

type Props = {
  to: string
  title: string
  icon?: string
  materialIcon?: string
  fontIcon?: string
  hasBullet?: boolean,
  className?: string,
}

const AsideMenuItemWithSub: React.FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  materialIcon,
  fontIcon,
  className,
  hasBullet,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)
  const { config } = useLayout()
  const { aside } = config

  const menuLinkRef = useRef<HTMLElement>(null)

  useEffect(() => {
    if (menuLinkRef.current)
      menuLinkRef.current.addEventListener("click", onMenuClick)
  }, [menuLinkRef])

  const onMenuClick = (ev: MouseEvent) => {
    if (!menuLinkRef.current)
      return;

    ev.stopPropagation();
    ev.stopImmediatePropagation();

    const el = menuLinkRef.current.parentElement!;
    if (el.classList.contains("show"))
      el.classList.remove("show")
    else
      el.classList.add("show")

    return false;
  }

  return (
    <div
      className={clsx(className, 'menu-item', { 'here show': isActive }, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link' ref={menuLinkRef}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        {materialIcon && <MUIIcon iconName={materialIcon} className="me-1" />}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx(className, 'menu-sub menu-sub-accordion', { 'menu-active-bg': isActive })}>
        {children}
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }
